module.exports = __webpack_public_path__ + "od-facebook/od-facebook-87e304890d56fa8ab539f45528a50a0f.svg";